import React from "react";
import { Header, Segment } from "semantic-ui-react";

const CrossTableDisplayPage = ({ crossTableData }) => {
    if (!crossTableData) {
        return <div style={{ textAlign: 'center', padding: '20px' }}><p>No cross table data available</p></div>;
    }

    const mainQuestions = Object.keys(crossTableData);
    
    // Get sub-questions from first main question (they should be the same for all)
    const subQuestions = Object.keys(crossTableData[mainQuestions[0]]);
    
    // Get all unique answers for each main question
    const mainQuestionAnswers = {};
    mainQuestions.forEach(mainQ => {
        const allAnswers = new Set();
        subQuestions.forEach(subQ => {
            const data = crossTableData[mainQ][subQ]?.data;
            if (data) {
                Object.values(data).forEach(categoryData => {
                    Object.keys(categoryData).forEach(answer => {
                        if (answer !== 'Total') {
                            allAnswers.add(answer);
                        }
                    });
                });
            }
        });
        mainQuestionAnswers[mainQ] = Array.from(allAnswers);
    });
    
    // Get categories for each sub-question
    const subQuestionCategories = {};
    subQuestions.forEach(subQ => {
        const data = crossTableData[mainQuestions[0]][subQ]?.data;
        if (data) {
            subQuestionCategories[subQ] = Object.keys(data);
        }
    });

    const getCellValue = (mainQuestion, subQuestion, category, answer) => {
        if (!crossTableData[mainQuestion]?.[subQuestion]?.data?.[category]) return 0;
        return crossTableData[mainQuestion][subQuestion].data[category][answer] || 0;
    };

    return (
        <div style={{ marginTop: '20px' }} className="cross-table-container">
            <Header as="h3">Cross Table Analysis</Header>
            
            <Segment>
                <div style={{ 
                    height: '600px', 
                    overflow: 'auto',
                    border: '2px solid #333'
                }}>
                    <table style={{
                        borderCollapse: 'collapse',
                        backgroundColor: 'white',
                        fontSize: '12px',
                        minWidth: '100%'
                    }}>
                        <thead>
                            <tr>
                                <th style={{
                                    minWidth: '120px',
                                    backgroundColor: '#f5f5f5',
                                    border: '1px solid #333',
                                    padding: '12px',
                                    position: 'sticky',
                                    top: 0,
                                    left: 0,
                                    zIndex: 1000
                                }}>
                                </th>
                                <th style={{
                                    minWidth: '100px',
                                    backgroundColor: '#f5f5f5',
                                    border: '1px solid #333',
                                    padding: '12px',
                                    position: 'sticky',
                                    top: 0,
                                    left: '120px',
                                    zIndex: 999
                                }}>
                                </th>
                                {subQuestions.map(subQ => (
                                    <th key={subQ} colSpan={(subQuestionCategories[subQ]?.length || 0) + 1} style={{
                                        backgroundColor: '#f5f5f5',
                                        border: '1px solid #333',
                                        padding: '12px',
                                        textAlign: 'center',
                                        fontWeight: 'bold',
                                        fontSize: '10px',
                                        position: 'sticky',
                                        top: 0,
                                        zIndex: 100
                                    }}>
                                        {subQ}
                                    </th>
                                ))}
                            </tr>
                            <tr>
                                <th style={{
                                    backgroundColor: '#f5f5f5',
                                    border: '1px solid #333',
                                    padding: '8px',
                                    position: 'sticky',
                                    top: '52px',
                                    left: 0,
                                    zIndex: 1000
                                }}>
                                </th>
                                <th style={{
                                    backgroundColor: '#f5f5f5',
                                    border: '1px solid #333',
                                    padding: '8px',
                                    position: 'sticky',
                                    top: '52px',
                                    left: '120px',
                                    zIndex: 999
                                }}>
                                </th>
                                {subQuestions.map(subQ => [
                                    ...subQuestionCategories[subQ]?.map(category => (
                                        <th key={`${subQ}-${category}`} style={{
                                            minWidth: '80px',
                                            backgroundColor: '#f9f9f9',
                                            border: '1px solid #333',
                                            padding: '8px',
                                            textAlign: 'center',
                                            fontWeight: 'bold',
                                            fontSize: '9px',
                                            position: 'sticky',
                                            top: '52px',
                                            zIndex: 100
                                        }}>
                                            {category}
                                        </th>
                                    )) || [],
                                    <th key={`${subQ}-Total`} style={{
                                        minWidth: '80px',
                                        backgroundColor: '#e6f3ff',
                                        border: '1px solid #333',
                                        padding: '8px',
                                        textAlign: 'center',
                                        fontWeight: 'bold',
                                        fontSize: '9px',
                                        position: 'sticky',
                                        top: '52px',
                                        zIndex: 100
                                    }}>
                                        Total
                                    </th>
                                ])}
                            </tr>
                        </thead>
                        <tbody>
                            {mainQuestions.map((mainQuestion, mainIndex) => 
                                mainQuestionAnswers[mainQuestion].map((answer, answerIndex) => (
                                    <tr key={`${mainQuestion}-${answer}`}>
                                        {answerIndex === 0 && (
                                            <td rowSpan={mainQuestionAnswers[mainQuestion].length} style={{
                                                fontWeight: 'bold',
                                                backgroundColor: '#e8f4fd',
                                                border: '1px solid #333',
                                                padding: '8px',
                                                fontSize: '11px',
                                                verticalAlign: 'middle',
                                                textAlign: 'center',
                                                writingMode: 'vertical-rl',
                                                transform: 'rotate(180deg)',
                                                position: 'sticky',
                                                left: 0,
                                                zIndex: 500
                                            }}>
                                                {mainQuestion}
                                            </td>
                                        )}
                                        <td style={{
                                            fontWeight: 'bold',
                                            backgroundColor: '#f0f8ff',
                                            border: '1px solid #333',
                                            padding: '8px',
                                            fontSize: '11px',
                                            verticalAlign: 'middle',
                                            position: 'sticky',
                                            left: '120px',
                                            zIndex: 499
                                        }}>
                                            {answer}
                                        </td>
                                        {subQuestions.map(subQ => [
                                            ...subQuestionCategories[subQ]?.map(category => {
                                                const value = getCellValue(mainQuestion, subQ, category, answer);
                                                return (
                                                    <td key={`${subQ}-${category}-${answer}`} style={{
                                                        border: '1px solid #333',
                                                        padding: '6px',
                                                        textAlign: 'center',
                                                        backgroundColor: 'white',
                                                        fontSize: '11px',
                                                        fontWeight: value > 0 ? 'bold' : 'normal',
                                                        color: value > 0 ? '#333' : '#ccc'
                                                    }}>
                                                        {value > 0 ? value : '-'}
                                                    </td>
                                                );
                                            }) || [],
                                            <td key={`${subQ}-Total-${answer}`} style={{
                                                border: '1px solid #333',
                                                padding: '6px',
                                                textAlign: 'center',
                                                backgroundColor: '#f0f8ff',
                                                fontSize: '11px',
                                                fontWeight: 'bold'
                                            }}>
                                                {subQuestionCategories[subQ]?.reduce((total, category) => {
                                                    return total + getCellValue(mainQuestion, subQ, category, answer);
                                                }, 0) || 0}
                                            </td>
                                        ])}
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </Segment>
        </div>
    );
};

export default CrossTableDisplayPage;
